/** Single place that reads `import.meta.env.VITE_*` for the web app. */

const viteEnv =
  (import.meta as ImportMeta & { env?: Record<string, string | undefined> })
    .env ?? {};

const viteApiUrl = viteEnv.VITE_API_URL;
const viteGoogleMapsApiKey = viteEnv.VITE_PUBLIC_GOOGLE_MAPS_API_KEY;
const viteGoogleMapsMapId = viteEnv.VITE_PUBLIC_GOOGLE_MAPS_MAP_ID;

const DEFAULT_HEARTBEAT_INTERVAL_MIN_SECONDS = 10;
const DEFAULT_HEARTBEAT_INTERVAL_MAX_SECONDS = 3600;

function readPositiveIntEnv(raw: string | undefined, fallback: number): number {
  if (raw == null || raw.trim() === '') {
    return fallback;
  }
  const parsed = Number(raw);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
}

/**
 * Auth + OpenAPI base URL (`initializeApiClient`, generated clients that expect one origin).
 * Empty string = same-origin (use Vite `/api` proxy via `VITE_DEV_API_PROXY_TARGET`).
 * Unset defaults to local API.
 */
export const API_URL =
  viteApiUrl === undefined
    ? 'http://localhost:3000'
    : viteApiUrl.replace(/\/$/, '');

export const KNOWLEDGE_API_URL = API_URL;

export const GOOGLE_MAPS_API_KEY = viteGoogleMapsApiKey?.trim() ?? '';
export const GOOGLE_MAPS_MAP_ID = viteGoogleMapsMapId?.trim() ?? '';

export const OCPP_HEARTBEAT_INTERVAL_MIN_SECONDS = readPositiveIntEnv(
  viteEnv.VITE_OCPP_HEARTBEAT_INTERVAL_MIN_SECONDS,
  DEFAULT_HEARTBEAT_INTERVAL_MIN_SECONDS,
);
export const OCPP_HEARTBEAT_INTERVAL_MAX_SECONDS = readPositiveIntEnv(
  viteEnv.VITE_OCPP_HEARTBEAT_INTERVAL_MAX_SECONDS,
  DEFAULT_HEARTBEAT_INTERVAL_MAX_SECONDS,
);
